export const forgotPasswordInitialState = {
  forgotPasswordFetch: false,
  forgotPasswordParams: {},
  forgotPasswordResponse: [],
  forgotPasswordError: {},
};
